import { FieldTypes } from '../../constants'
import { addFieldRow } from '../../fields'
import {
  BooleanField,
  DateTimeField,
  DropdownField,
  FieldMap,
  TextAreaField,
  TextField,
} from '../../types'
import { ProcedureCategory, ProcedureName } from '../types'

const procedureNameField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Procedure',
  allowOther: true,
  options: [
    { text: 'Amniotomy (AROM)', id: ProcedureName.AMNIOTOMY },
    { text: 'Foley Bulb', id: ProcedureName.FOLEY_BULB },
    { text: 'Epidural Placement', id: ProcedureName.EPIDURAL_PLACEMENT },
    { text: 'Suturing', id: ProcedureName.SUTURING },
    { text: 'FSE / IUPC', id: ProcedureName.FSE_IUPC },
  ],
}

const categoryField: DropdownField<ProcedureCategory> = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Category',
  inputType: 'radio',
  options: [
    { text: 'Intervention', id: ProcedureCategory.INTERVENTION },
    { text: 'Anesthesia', id: ProcedureCategory.ANESTHESIA },
    { text: 'Repair', id: ProcedureCategory.REPAIR },
    { text: 'Monitoring', id: ProcedureCategory.MONITORING },
  ],
}

const startTimeField: DateTimeField = {
  type: FieldTypes.DATETIME,
  placeholder: 'Start Time',
  defaultToNow: true,
}

const endTimeField: DateTimeField = {
  type: FieldTypes.DATETIME,
  placeholder: 'End Time',
  optional: true,
}

const providerIdField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Provider',
}

const assistantIdField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Assistant Provider',
  optional: true,
}

const detailsField: TextAreaField = {
  type: FieldTypes.TEXTAREA,
  placeholder: 'Details',
  optional: true,
}

const isSuccessfulField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  placeholder: 'Successful',
  inputType: 'radio',
  yesText: 'Yes',
  noText: 'No',
}

const consentObtainedField: BooleanField = {
  type: FieldTypes.BOOLEAN,
  placeholder: 'Consent Obtained',
  inputType: 'radio',
  yesText: 'Yes',
  noText: 'No',
}

export const procedureField: FieldMap = {
  name: 'Procedure',
  children: {
    procedureName: addFieldRow(procedureNameField, { index: 0, flex: 2 }),
    category: addFieldRow(categoryField, { index: 0, flex: 1 }),
    startTime: addFieldRow(startTimeField, { index: 1, flex: 1 }),
    endTime: addFieldRow(endTimeField, { index: 1, flex: 1 }),
    providerId: addFieldRow(providerIdField, { index: 2, flex: 1 }),
    assistantId: addFieldRow(assistantIdField, { index: 2, flex: 1 }),
    consentObtained: addFieldRow(consentObtainedField, { index: 3, flex: 1 }),
    isSuccessful: addFieldRow(isSuccessfulField, { index: 3, flex: 1 }),
    details: detailsField,
  },
}
